// Local dependencies
import {
  Category,
  GetCategory,
  GetCategoryActionType,
  GetCategoryError,
  GetCategoryInput,
  GetCategorySuccess,
} from './types';

export function getCategory(input: GetCategoryInput): GetCategory {
  return {
    type: GetCategoryActionType.GET_CATEGORY,
    input,
  };
}

export function getCategorySuccess(category: Category): GetCategorySuccess {
  return {
    type: GetCategoryActionType.GET_CATEGORY_SUCCESS,
    category,
  };
}

export function getCategoryError(error: Error): GetCategoryError {
  return {
    type: GetCategoryActionType.GET_CATEGORY_ERROR,
    error,
  };
}
